import * as yup from 'yup';
const PortfolioEditSchema = () =>
  yup.object({
    referenceCurrency: yup.string().required('Reference currency is required'),
    portfolioType: yup.string().required('Account type is required'),
    sequenceNumber: yup.string().required('Sequence number is required'),
    rubrik: yup.string().required('Rubrik is required'),

    cashAccounts: yup
      .array()
      .of(
        yup.object({
          currency: yup.string().required('Currency is required'),
          accountType: yup.string().required('Cash account type is required'),
        }),
      )
      .min(1, 'At least one cash account is required')
      .required(),
  });

export default PortfolioEditSchema;
